module.exports = __webpack_public_path__ + "static/img/ldt2.ee6df22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ldt2.png
// module id = ATG5
// module chunks = 0